import React from "react";
import { ArrowUpCircleIcon } from "@heroicons/react/24/solid";
import { DetailedHTMLProps, InputHTMLAttributes } from "react";

interface IProps {
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  btnClassName?: string;
  disabled?: boolean;
  inputClassName?: string;
}

const UploadFileButton: React.FC<IProps> = ({
  onChange,
  btnClassName,
  disabled = false,
  inputClassName = "hidden",
}) => {
  return (
    <div>
      <button
        className={`text-quinary border-quinary opacity-100 hover:scale-90 transition duration-500 shadow-md border-quinary
          bg-transparent hover:bg-quinary text-quinary group relative flex justify-center py-1 px-3 border border-transparent text-xs 
          font-medium rounded-full hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-quinary 
          focus:ring-opacity-70 ${btnClassName}`}
        onClick={() => {
          const input = document.getElementById(
            "fileInput"
          ) as HTMLInputElement | null;
          if (input && input) {
            input.click();
          }
        }}
      >
        <ArrowUpCircleIcon className="h-4 w-4 mr-2" />
        Upload file
      </button>
      <input
        id="fileInput"
        type="file"
        onChange={onChange}
        disabled={disabled}
        className={inputClassName}
      />
    </div>
  );
};

export default UploadFileButton;
